<template>
    <div>
        <carousel
            :nav="false"
            :responsive="{
                0: {
                    items: 1,
                    dots: false,
                    autoWidth: false,
                    loop: false,
                    center: false,
                },
                552: {
                    items: 3,
                    dots: false,
                    autoWidth: false,
                    loop: false,
                    center: false,
                },
                768: {
                    items: 5,
                    dots: true,
                    autoWidth: true,
                    loop: true,
                    center: true,
                }
            }"
        >
            <div v-for="(person, index) in people" :key="index" class="team-member">
                <b-avatar :src="person.picture" size="8rem"></b-avatar>
                <a :href="person.linkedinUrl" target="_blank" rel="noreferrer">
                    {{ person.name }}
                </a>
                <h6>{{ person.title }}</h6>
            </div>
        </carousel>
    </div>
</template>

<script>
import carousel from 'vue-owl-carousel';
import PeopleData from '@/data/people.json';

export default {
    name: 'team-slider',
    components: { carousel },
    data () {
        return {
            people: PeopleData,
        };
    },
};
</script>
<style lang="scss">
.owl-stage{
    @include media-breakpoint-down(sm) {
        width: 100% !important;
        transform: none !important;
    }
}
.owl-item {
    opacity: 0.4;
    @include media-breakpoint-down(sm) {
        opacity: 1;
    }
}
.owl-item.center {
    opacity: 1;
}
.owl-theme .owl-dots .owl-dot {
    outline: none;
}
.owl-theme .owl-nav.disabled + .owl-dots {
    margin-top: 25px !important;
}
.owl-theme .owl-dots .owl-dot span {
    background: #505B64 !important;
}
.owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span {
    background: #9B64BE !important;
}
.team-member {
    width: 231px;
    margin: 0 auto;
    text-align: center;
    padding: 0 30px;
    @include media-breakpoint-down(sm) {
        height: 235px;
        margin-bottom: 10px;
        width: 100%;
        padding: 0 20px;
    }
    a {
        display: block;
        color: #ffffff;
        text-decoration: none;
        margin-top: 15px;
        margin-bottom: 0.3rem;
        font-size: 20px;
        font-weight: 700;
        &:hover {
            color: #9b63be;
        }
    }

    h6 {
        font-size: 16px;
        color: #B5C0C7;
    }
}
</style>
